var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorsPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 129,
    viewBox: "0 0 67 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0432 125.835C66.6528 126.445 66.6528 127.433 66.0432 128.043C65.4336 128.652 64.4453 128.652 63.8357 128.043L1.39665 65.6038C0.787053 64.9942 0.787053 64.0058 1.39665 63.3962L63.8357 0.957199C64.4453 0.3476 65.4336 0.3476 66.0432 0.957199C66.6528 1.5668 66.6528 2.55516 66.0432 3.16475L4.6858 64.5L66.0432 125.835Z",
    fill: "#FB5B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorsPrev);
export default __webpack_public_path__ + "static/media/doctors__prev.aa2f2d48fb79e80a008306de45cb7389.svg";
export { ForwardRef as ReactComponent };